var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFullScreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2046 8.61813L10.839 9.98374L8.79667 7.94144L7.88627 8.85185L9.92857 10.8942L8.56295 12.2598H12.2046V8.61813ZM0.615234 4.31204L1.98085 2.94643L4.02315 4.98873L4.93356 4.07832L2.89125 2.03602L4.25687 0.67041H0.615234V4.31204ZM12.2046 0.67041H8.56295L9.92857 2.03602L7.88627 4.07832L8.79667 4.98873L10.839 2.94643L12.2046 4.31204V0.67041ZM0.615234 12.2598H4.25687L2.89125 10.8942L4.93356 8.85185L4.02315 7.94144L1.98085 9.98374L0.615234 8.61813V12.2598Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullScreen);
export default __webpack_public_path__ + "static/media/fullScreen.b2095f50f72eafb70a8bf2ff8f408503.svg";
export { ForwardRef as ReactComponent };